<template>
    <div>
        Once you click finish, your business will be created and you will be automatically redirected to the business page
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    
}
</script>